import React from 'react'
import clsx from 'clsx'
import { Tabs, Tab } from '@mui/material'

import SettingsPage from '../SettingsPage'
import GroupSettings from './Settings/GroupSettings'
import FlowSettings from './Settings/FlowSettings'

import { ObjectType, nameMap } from './types'
import useStyles from './styles'

enum TabType {
  CustomField = 'custom-field',
  Flows = 'flows'
}

const CustomFieldsSettings: React.FC = () => {
  const [mainTab, setMain] = React.useState(TabType.CustomField)
  const [subTab, setSubTab] = React.useState(ObjectType.ExternalUser)

  const classes = useStyles()

  return (
    <SettingsPage
      above={
        <Tabs
          value={mainTab}
          onChange={(_, val) => setMain(val)}
          className={classes.tabs}
        >
          <Tab
            label='Custom Fields'
            value={TabType.CustomField}
            classes={{ root: classes.tab }}
          />

          <Tab
            label='Flows'
            value={TabType.Flows}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      }
      disableBottomPadding
    >
      <SettingsPage
        above={
          <Tabs
            value={subTab}
            onChange={(_, val) => setSubTab(val)}
            className={clsx(classes.tabs, classes.subTabs)}
          >
            <Tab
              label='Contacts'
              value={ObjectType.ExternalUser}
              classes={{ root: classes.tab }}
            />

            <Tab
              label='Tasks'
              value={ObjectType.Task}
              classes={{ root: classes.tab }}
            />

            <Tab
              label='Users'
              value={ObjectType.User}
              classes={{ root: classes.tab }}
            />
          </Tabs>
        }
        title={`${nameMap[subTab]} ${
          mainTab === TabType.CustomField ? 'Custom Fields' : 'Flows'
        }`}
        disableBottomPadding
      >
        {mainTab === TabType.CustomField && <GroupSettings tab={subTab} />}

        {mainTab === TabType.Flows && <FlowSettings tab={subTab} />}
      </SettingsPage>
    </SettingsPage>
  )
}

export default CustomFieldsSettings
